import { useCallback, useRef } from 'react';
import { useSSEConnection } from '../../../hooks/useSSEConnection';
import { useReportProgress } from '../../../stores/reportProgressStore';

interface ReportProgressEvent {
  type: 'start' | 'progress' | 'error' | 'complete';
  total: number;
  processed: number;
  success: number;
  failed: number;
  timestamp: string;
  status: 'in_progress' | 'complete';
}

export const useReportProgressSSE = () => {
  const { updateFromEvent, complete: completeProgress } = useReportProgress();
  const disconnectRef = useRef<(() => void) | null>(null);

  const handleMessage = useCallback(
    (data: ReportProgressEvent) => {
      updateFromEvent(data);

      if (data.type === 'complete') {
        completeProgress();
        disconnectRef.current?.();
      }
    },
    [updateFromEvent, completeProgress]
  );

  const { connect, disconnect } = useSSEConnection<ReportProgressEvent>(
    '/report-generation-progress',
    { onMessage: handleMessage }
  );

  disconnectRef.current = disconnect;

  return { connect, disconnect };
};
